module.exports = {
  fixedPrice: "fixedPrice",
  maxPrice: "maxPrice",
  taximeterPrice: "taximeterPrice",
};
